export const blackColor: string = '#181B1C';
export const greyColor: string = '#262729';
export const greyLightColor: string = '#484B4E';
export const greyLighterColor: string = '#6D7174';
export const greyMoreLighterColor: string = "#8A9094";
export const whiteColor: string = '#ffff';

export const darkBlueColor: string = '#252958';
export const blueColor: string = '#393E85';
export const blueLightColor: string = '#484EA5';

export const greenColor: string = '#66BA7E';
export const purpleColor: string = '#9400D3';
export const orangeColor: string = '#EE6F00';
export const redColor: string = '#CF4A4A'

export const backgroundColor: string = blackColor;
export const backgroundColorLight: string = greyColor;
export const backgroundColorLighter: string = greyLightColor;
export const backgroundColorMoreLighter: string = greyMoreLighterColor;

export const backgroundHoverColor: string = greyLighterColor;

export const dangerColor: string = redColor;
export const warningColor: string = orangeColor;
export const successColor: string = greenColor;

export const primaryColor: string = blueColor;
export const accentColor: string = greenColor;
export const tertiaryColor: string = greyColor;

